import { client } from "../../../../Infrastructure/agent";
export const FlowsationPerformanceService = {
  loadInitialData: () => client.get("/flowstation/GetInitialData"),
  getDashboardData: (year, month) =>
    client.post("/flowstation/GetDashboardData", { year, month }),
  getuniqueFlowstationsData: () => client.get("/flowstation/GetFlowstations"),

  getFlowstationPlotData: (flowstationId) =>
    client.post("/flowstation/GetFlowstationPlotData", { flowstationId }),
};

